module.exports = __webpack_public_path__ + "static/media/smile6.d1c4d420.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/smileImg/smile6.png
// module id = 79
// module chunks = 0